var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"mainOuter"}},[_c('PageHeader'),_c('main',{attrs:{"id":"main"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1),_c('PageFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }